export default "__VITE_ASSET__4kVfoiIm__"